import $ from 'jquery';

import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { SiebelProduct } from './Tc.Module.ServiceAvailability';

export interface OrderButtonsInitData {
	noLoginUrl : string;
	href? : string;
	registrationUrl? : string | null;
	update? : boolean;
}

/**
 * Order Overlay Order Buttons for MAP Bundle Order or Lego Container pages
 *
 * @author Michael Keller
 * @namespace Tc.Module
 * @class OrderOverlayOrderButtons
 * @extends Tc.Module
 */
export default class OrderOverlayOrderButtons extends Module {
	private $buttonHolders! : JQuery;

	private buttonOverridesData? : Record<string, string>[];

	public on(callback : Hook) {
		// Collect button holders and write current texts to data-attributes
		this.$buttonHolders = this.$ctx.find('.existing-customer, .without-login, .phone-contact');
		this.$buttonHolders.find('span, p, a').each(function() {
			$(this).data('default-text', $(this).text());
		});

		this.addSiteCatalystTracking();

		// Handle click on button "get in contact" which is displayed after a search for a phonenumber
		this.$ctx.find('.phone-contact a').click(e => {
			e.preventDefault();
			if ((window as any).SCS?.HelpWidget?.open) {
				(window as any).SCS.HelpWidget.open('contact');
			}
		});

		this.readButtonOverrides();

		callback();
	}

	private addSiteCatalystTracking() {
		const win = window as any;

		this.$ctx.find('.existing-customer a').click(e => {
			const $el = $(e.target as HTMLAnchorElement);
			const siteCatalyst = win.s || win.s_one;
			if (siteCatalyst && siteCatalyst.tl) {
				if($el.hasClass('goToLogin')) {
					siteCatalyst.tl(this, 'o', 'OrderOverlay_OrderButton_GoToLogin');
					window.location.href = $el[0].href;
				} else {
					siteCatalyst.tl(this, 'o', 'OrderOverlay_OrderButton_WithLogin');
				}
			}
		});

		this.$ctx.find('.without-login a').click(function() {
			const siteCatalyst = win.s || win.s_one;
			if (siteCatalyst && siteCatalyst.tl) {
				siteCatalyst.tl(this, 'o', 'OrderOverlay_OrderButton_WithoutLogin');
			}
		});
	}

	/*
	 * Reads button override texts if specified by the author
	 */
	private readButtonOverrides() {
		this.buttonOverridesData = this.$ctx
			.find('.button-overrides p')
			.map((_i, el) => {
				const $el = $(el);

				return {
					nologinButtonLinkText: $el.find('.nologinButtonLinkText').text(),
					nologinButtonText: $el.find('.nologinButtonText').text(),
					nologinButtonTitle: $el.find('.nologinButtonTitle').text(),
					orderButtonLinkText: $el.find('.orderButtonLinkText').text(),
					orderButtonText: $el.find('.orderButtonText').text(),
					orderButtonTitle: $el.find('.orderButtonTitle').text(),
					phonecontactButtonLinkText: $el.find('.phonecontactButtonLinkText').text(),
					phonecontactButtonText: $el.find('.phonecontactButtonText').text(),
					phonecontactButtonTitle: $el.find('.phonecontactButtonTitle').text(),
					productId: $el.find('.productId').text(),
				};
			})
			.get();
	}

	private getButtonOverridesByProductId(productId : string) {
		if (this.buttonOverridesData) {
			for (const buttonOverride of this.buttonOverridesData) {
				if (buttonOverride.productId === productId || buttonOverride.productId === '*') {
					return buttonOverride;
				}
			}
		}

		return {};
	}

	private defaultText(selector : string, override : string) {
		const $el = this.$ctx.find(selector);
		$el.text(override ?? $el.data('default-text'));
	}

	private overrideButtonTexts(data : Record<string, string>) {
		this.defaultText('.existing-customer h4 span', data?.orderButtonTitle);
		this.defaultText('.existing-customer .description', data?.orderButtonText);
		this.defaultText('.existing-customer a', data?.orderButtonLinkText);
		this.defaultText('.without-login h4 span', data?.nologinButtonTitle);
		this.defaultText('.without-login .description', data?.nologinButtonText);
		this.defaultText('.without-login a', data?.nologinButtonLinkText);
		this.defaultText('.phone-contact h4 span', data?.phonecontactButtonTitle);
		this.defaultText('.phone-contact .description', data?.phonecontactButtonText);
		this.defaultText('.phone-contact a', data?.phonecontactButtonLinkText);
	}

	// Fired by Tc.Module.OrderOverlay.js
	public onOrderButtonsInit(data : OrderButtonsInitData) {
		const mod = this;
		if (!data) {
			return;
		}

		mod.log('onOrderButtonsInit', data.href, data.noLoginUrl);
		mod.$ctx.find('.existing-customer a').attr('href', data.href ?? null).removeData();
		mod.$ctx.find('.without-login a').attr('href', data.noLoginUrl).removeData();
		mod.$ctx.find('.new-customer a').attr('href', data.registrationUrl ?? null).removeData();
		if (data.update) {
			return; // Only update URLs
		}

		if (data.noLoginUrl) {
			mod.$ctx.find('.without-login').removeClass('hidden').removeClass('no-nologin-url');
		} else {
			mod.$ctx.find('.without-login').addClass('hidden').addClass('no-nologin-url');
		}
	}

	// Fired by Tc.Module.OrderOverlay.js
	public onOrderButtonsHide() {
		this.$ctx.hide();
	}

	// Fired by Tc.Module.OrderOverlay.js
	public onOrderButtonsShow() {
		this.$ctx.show();
	}

	public onCheckTypeChange(type : 'address' | 'none') {
		this.log('onCheckTypeChange', type);
		const win = window as any;
		if (type === 'none') {
			if (win.SCS?.HelpWidget) {
				// Only needed if a help widget is available
				this.$ctx.find('.phone-contact').removeClass('hidden').addClass('half-width');
				this.$ctx.find('.existing-customer').addClass('half-width');
			}
			this.$ctx.find('.without-login').addClass('hidden');
		} else {
			this.$ctx.find('.phone-contact').addClass('hidden').removeClass('half-width');
			this.$ctx.find('.existing-customer').removeClass('half-width');
			if (!this.$ctx.find('.without-login').is('.no-nologin-url')) {
				this.$ctx.find('.without-login').removeClass('hidden');
			}
		}
	}

	public onUpdateProductId(data : SiebelProduct) {
		this.log('onUpdateProductId', data);
		if (data && data.siebelId) {
			this.overrideButtonTexts(this.getButtonOverridesByProductId(data.siebelId));
		}
	}


}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/ecommerce/Tc.Module.OrderOverlayOrderButtons.ts